import { render } from "./Step_three.vue?vue&type=template&id=fd37da64"
import script from "./Step_three.vue?vue&type=script&lang=js"
export * from "./Step_three.vue?vue&type=script&lang=js"

import "./Step_three.vue?vue&type=style&index=0&id=fd37da64&lang=less"
script.render = render

export default script